import React, {useState} from 'react'
import styles from './UIGameHelpButtons.module.scss'
import {UIGameHelpFullScreenButton} from './UIGameHelpFullScreenButton'
import {UIGameHelpInformationButton} from './UIGameHelpInformationButton'
import {UIGameHelpRulesButton} from './UIGameHelpRulesButton'
import {UIGameHelpUserSettingsButton} from './UIGameHelpUserSettingsButton'
import {UIGameHelpRulesButtonProvider} from './UIGameHelpRulesButton/UIGameHelpRulesButtonContext'
import {UIGameFullScreenProvider} from './UIGameHelpFullScreenButton/UIGameHelpFullScreenContext'
import {UIGameHelpLeaveGameProvider} from './UIGameHelpLeaveGameContext'
import {useUIGameSocketContext} from '../../contexts/UIGameSocketContext'
import {UIGameHelpInformationPopup} from './UIGameHelpInformationPopup/UIGameHelpInformationPopup'
import {ModeSettingEnum} from '@colonist/types'
import {useUIContext} from '../../contexts/UIContext'
import {useGameStore} from '../../store/GameStoreContext'
import {useRequestPause} from '../../hooks/usePause'
import clsx from 'clsx'

export const UIGameHelpUserSettingsButtonContainer = ({
    isRulesOptionVisible,
    isGameInfoOptionVisible,
    initialCanResign,
}: {
    isRulesOptionVisible: boolean
    isGameInfoOptionVisible: boolean
    initialCanResign: boolean
}) => {
    const requestPause = useRequestPause()
    const {sendDisableKarma} = useUIGameSocketContext()
    const setIsOpenSettings = useGameStore((state) => state.gameUserSettings.setIsOpenSettings)
    const modeSetting = useGameStore((state) => state.gameSettings.modeSetting)
    const victoryPointsToWin = useGameStore((state) => state.gameSettings.victoryPointsToWin)
    const isMyColorSpectator = useGameStore((state) => state.isMyColorSpectator)
    const isMechanicIslandExplorationActive = useGameStore((state) => state.gameState.mechanicIslandExplorationState) !== undefined
    const myColor = useGameStore((state) => state.myColor)
    const [isOpenGameInfo, setIsOpenGameInfo] = useState(false)

    return (
        <>
            <div className={styles.settingsButtonContainer}>
                <UIGameHelpRulesButtonProvider>
                    <UIGameHelpLeaveGameProvider initialCanResign={initialCanResign}>
                        <UIGameHelpUserSettingsButton
                            isPlayerSpectator={isMyColorSpectator}
                            isRulesOptionVisible={isRulesOptionVisible}
                            isGameInfoOptionVisible={isGameInfoOptionVisible}
                            onSettingsClick={() => setIsOpenSettings(true)}
                            onPauseGameClick={requestPause}
                            onDisableKarmaClick={sendDisableKarma}
                            onGameInfoClick={() => setIsOpenGameInfo(true)}
                        />
                    </UIGameHelpLeaveGameProvider>
                </UIGameHelpRulesButtonProvider>
            </div>
            <UIGameHelpInformationPopup
                isOpen={isOpenGameInfo}
                isMechanicIslandExplorationActive={isMechanicIslandExplorationActive}
                onClose={() => setIsOpenGameInfo(false)}
                gameMode={modeSetting}
                playerColor={myColor}
                victoryPointsToWin={victoryPointsToWin} />
        </>
    )
}

export const UIGameHelpButtons = ({initialCanResign, className}: {initialCanResign: boolean, className: string}) => {
    const {isUserOnDiscord, isUserOnMobile} = useUIContext()
    const modeSetting = useGameStore((state) => state.gameSettings.modeSetting)
    const isMechanicIslandExplorationActive = useGameStore((state) => state.gameState.mechanicIslandExplorationState) !== undefined
    const victoryPointsToWin = useGameStore((state) => state.gameSettings.victoryPointsToWin)
    const myColor = useGameStore((state) => state.myColor)
    const isOpenSettings = useGameStore((state) => state.gameUserSettings.isOpenSettings)
    const isBeginnerMode = modeSetting === ModeSettingEnum.BeginnerModeClassic4P

    if(isOpenSettings === true) return null

    return (
        <div className={clsx(styles.container, className)} style={{flexDirection: isUserOnMobile ? 'row' : 'column'}}>
            <UIGameHelpUserSettingsButtonContainer
                initialCanResign={initialCanResign}
                isRulesOptionVisible={false}
                isGameInfoOptionVisible={false}
            />
            {!isBeginnerMode && <>
                <UIGameHelpRulesButtonProvider>
                    <UIGameHelpRulesButton />
                </UIGameHelpRulesButtonProvider>
                {isUserOnDiscord === false && <UIGameFullScreenProvider>
                    <UIGameHelpFullScreenButton />
                </UIGameFullScreenProvider>}
                <UIGameHelpInformationButton
                    gameMode={modeSetting}
                    isMechanicIslandExplorationActive={isMechanicIslandExplorationActive}
                    playerColor={myColor}
                    victoryPointsToWin={victoryPointsToWin}/>
            </>}
        </div>
    )
}
